export const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const getLocalizedDayOfWeek = (
  dayOfWeek,
  form = "long",
  locale = navigator.language,
) => {
  const numericDayOfWeek = Number.isFinite(dayOfWeek)
    ? dayOfWeek
    : getNumericDayOfWeek(dayOfWeek);
  const offset = new Date();
  offset.setDate(offset.getDate() + numericDayOfWeek - offset.getDay());
  return offset.toLocaleDateString(locale, { weekday: form });
};

export const getNumericDayOfWeek = (dayOfWeek) => {
  return DAYS_OF_WEEK.indexOf(dayOfWeek);
};



// WEBPACK FOOTER //
// ./src/components/util/DateTimeUtil.js